<template>
  <div
    v-accessibility-focus="toggle"
    role="checkbox"
    :aria-checked="value"
    :aria-labelledby="ariaLabelledBy"
    class="o-checkbox"
    :class="{ 'is-active': active, 'is-required': required }"
  >
    <i
      class="o-checkbox__icon o-icon"
      :class="[active ? 'o-icon--checkbox-marked' : 'o-icon--checkbox-blank']"
      aria-hidden="true"
    ></i>
    <div
      :id="ariaLabelledBy"
      class="o-checkbox__label"
      @keydown.enter.stop
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
  import { getRandomString } from '@/shared/utils';

  export default {
    model: {
      prop: 'modelValue',
    },
    props: {
      required: {
        type: Boolean,
        default: false,
      },
      modelValue: {
        type: [Array, Boolean],
        default: false,
      },
      value: {
        type: [Boolean, Number, String],
        default: false,
      },
    },
    data() {
      return {
        compId: getRandomString(8),
      };
    },
    computed: {
      active() {
        if (this.modelValue instanceof Array) {
          return this.modelValue.includes(this.value);
        }

        return this.modelValue;
      },
      ariaLabelledBy() {
        return `${this.compId}_checkbox`;
      },
    },
    methods: {
      isLink(target) {
        return target.tagName.toLowerCase() === 'a';
      },
      toggle(event) {
        if (this.isLink(event.target)) {
          return;
        }

        if (this.modelValue instanceof Array) {
          const newValue = [...this.modelValue];

          if (!this.active) {
            newValue.push(this.value);
          } else {
            newValue.splice(newValue.indexOf(this.value), 1);
          }

          this.$emit('input', newValue);
          return;
        }

        this.$emit('input', !this.active);
      },
    },
  };
</script>
